import React, { Component } from "react";
import HeaderBar from "../../components/header/HeaderBar";
import AdminUserTableContainer from "./AdminUserTableContainer";
import UpgradesTableContainer from "./UpgradesTableContainer";
import TournamentListContainer from "./TournamentListContainer";
import TournamentsInAppContainer from "./TournamentsInAppContainer";
import ReportsContainer from "./ReportsContainer";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

class AdminContainer extends Component {
  state = {
    value: 0,
    logs: [],
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    return (
      <div>
        <HeaderBar user={this.props.user} />
        {this.props.admins.indexOf(this.props.user.uid) !== -1 && (
          <div style={{ marginTop: 70 }}>
            <Tabs
              value={this.state.value}
              onChange={this.handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="off"
            >
              <Tab key={0} value={0} label="Search" />
              <Tab key={1} value={1} label="Tournaments" />
              <Tab key={2} value={2} label="Upgrades" />
              <Tab key={3} value={3} label="App" />
              <Tab key={4} value={4} label="Reports" />
            </Tabs>
            <div
              style={{ display: this.state.value === 0 ? "initial" : "none" }}
            >
              <AdminUserTableContainer />
            </div>
            <div
              style={{ display: this.state.value === 1 ? "initial" : "none" }}
            >
              {this.state.value === 1 && (
                <TournamentListContainer
                  admins={this.props.admins}
                  user={this.props.user}
                />
              )}
            </div>
            <div
              style={{ display: this.state.value === 2 ? "initial" : "none" }}
            >
              {this.state.value === 2 && <UpgradesTableContainer />}
            </div>
            <div
              style={{ display: this.state.value === 3 ? "initial" : "none" }}
            >
              {this.state.value === 3 && (
                <TournamentsInAppContainer
                  admins={this.props.admins}
                  user={this.props.user}
                />
              )}
            </div>
            <div
              style={{ display: this.state.value === 4 ? "initial" : "none" }}
            >
              {this.state.value === 4 && (
                <ReportsContainer
                  admins={this.props.admins}
                  user={this.props.user}
                />
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default AdminContainer;
